// 错误码
const errorDict = {
  63404: '操作失败', // 入参有问题
  63117: '操作失败，请重试', // 版本校验不成功
  63116: '自选基金已达上限', // 添加自选达到上限(当前最大500)
  63120: 'token验证错误', // 通行证校验不通过，需要发通知刷新CUToken
  63212: '与已有分组重名', // 分组重复
  63211: '编辑分组失败', // 分组不存在
  63213: '包含敏感词，请重新输入', // 分组名称存在敏感词
  63214: '自选组合已达上限', // 添加自选组合达到上限(当前最大200)
  // "63215": '操作失败，请重试', // 自选子账户校验失败
  // "63216": '自选未公开', // 用户未公开自选
  63314: '添加自选主题已达上限', // 添加自选主题达到上限(当前最大200)
  63315: '该分组不存在', // 自选主题校验失败
  // "63316": '自选投顾code校验失败', // 投顾自选校验失败
  63317: '自选投顾已达上限', // 添加投顾自选达到上限200
  63318: '已超出一次性最大操作数量，请重试', // 一次性操作最大数量
  63329: '自选分组添加失败', // 自选分组添加失败
  63330: '添加分组已达上限', // 分组已达到上限
  63112: '该组存在该基金',
  63113: '该组不存在该只基金',
  80000: '系统维护中', // 系统维护只读
  80001: '系统维护中', // 系统维护不可读
  63301: '操作失败，请重试', // 品种页操作置顶接口版本错误
  63302: '操作失败，请重试', // 批量调整置顶排序传参校验失败
  63303: '智能主题分组中的基金无法单独删除', // 智能主题分组中的code无法单独删除
  63304: '操作失败', // 无法直接往智能分组中手动添加基金
};
// 自选接口请求错误
function InterceptOptionError(optionActionName = '') {
  return function InterceptOptionErrorFunc(target, property, descriptor) {
    return {
      ...descriptor,
      value(...args) {
        return new Promise((resolve, reject) => {
          descriptor.value
            .apply(this, args)
            .then((res) => {
              // 自选基金 组合 分组错误统一处理
              let errorCode = res.errorCode || res.ErrCode || '';
              errorCode = errorCode.toString();
              const errorText = errorDict[errorCode] || '';
              if (errorText) {
                let error = { key: optionActionName, errCode: errorCode, errData: errorText };
                // 接口失败，如果内部有新版本号，则需要更新，不能只依赖自选页更新，因为外部可能会直接进编辑分组等页面
                if (errorCode === 63117 || errorCode === '63117') {
                  error = {
                    ...error,
                    data: res?.data ?? {},
                  };
                }
                reject(error);
              } else {
                resolve(res);
              }
            })
            .catch((err) => {
              const error = { key: optionActionName, errCode: 'catch错误', errData: err };
              reject(error);
            });
        });
      },
    };
  };
}
export default InterceptOptionError;
